import { useEffect, useState } from "react";
import stl from "./OpenMenuSelection.module.css";
import { CDN_LINK } from "@globalConfig";
import CheckBox from "../AsideSubMenu/components/CheckBoxGroup/CheckBox/CheckBox";

function OpenMenuSelection({
  options,
  onChange,
  title,
  isOpen,
  isCampaign,
  filter,
  tempSelectedOptions,
  selectedOptions,
}) {
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  useEffect(() => {
    setIsOpenFilter(isOpen);
  }, []);

  return (
    <>
      <div
        className={[
          stl.container,
          !isOpenFilter ? stl.closedStyle : undefined,
          isCampaign ? stl.isCampaign : undefined,
        ].join(" ")}
      >
        <div
          className={stl.title}
          onClick={() => {
            isCampaign
              ? !isOpen && setIsOpenFilter(!isOpenFilter)
              : setIsOpenFilter(!isOpenFilter);
          }}
        >
          <strong>{title}</strong>
          <img
            src={CDN_LINK + "/assets/images/arrAcc.svg"}
            alt="arrow"
            width={"12px"}
            height={"7px"}
          />
        </div>
        {isOpenFilter && (
          <div >
            {options?.map((option, i) => {
              const isChecked =
                tempSelectedOptions?.find(
                  (item) =>
                    item.id === option.id &&
                    item?.filterField === "condition_id"
                ) ||
                selectedOptions?.find(
                  (item) =>
                    item.id === option.id &&
                    item?.filterField === "condition_id"
                )
                  ? true
                  : false;

              return (
                <CheckBox
                  disabled={false}
                  fieldName={filter.facetName}
                  key={option.id}
                  option={option}
                  label={option.name}
                  value={option.id}
                  onChange={onChange}
                  count={option.count}
                  checked={isChecked}
                  filter={filter}
                />
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}

export default OpenMenuSelection;
